<template>
  <b-container>
    <b-row>
      <b-col>
        <b-button variant="warning" size="sm"
          v-if="this.newDataAvailable === true"
          class="btn-reload-demands-and-purchase-offers"
          @click="reloadData()"
        >
          New data available. Click here to reload.
          <b-icon-arrow-repeat/>
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="12" sm="7"><h1>Purchase Offers</h1></b-col>
      <b-col cols="12" sm="5" v-if="status === localConstants.STATUS_FINISHED_LOADING" class="text-right">
        Last update: {{ lastUpdate }}
      </b-col>
    </b-row>
    <div v-if="status === localConstants.STATUS_LOADING">
      <b-row>
        <b-col class="text-center col-loading">
          <h3>Loading purchase offers <b-spinner/></h3>
        </b-col>
      </b-row>
    </div>
    <div v-if="status === localConstants.STATUS_ERROR_LOADING">
      <b-row class="justify-content-center">
        <b-col cols="8" class="text-center col-loading">
          <div class="alert alert-danger">
            Temporary Error during loading. Please try to refresh the page and see if the error persists.
          </div>
        </b-col>
      </b-row>
    </div>

    <b-row>
      <b-col>
        <b-row>
          <b-col>
            <h5 @click="showDemandFilter = !showDemandFilter" class="filtertoggle">
              Demand Filter
              <b-icon-chevron-up scale="1.5" v-if="showDemandFilter"/>
              <b-icon-chevron-down scale="1.5" v-else/>
            </h5>
          </b-col>
        </b-row>
        <transition name="fade">
          <b-row v-show="showDemandFilter">
            <b-col cols="12" md="3">
              <b-form-group label="Text">
                <b-form-input v-model="textFilter" size="sm" placeholder="Search in Variant, Brand, Model" />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group label="Brand">
                <b-form-select v-model="brandSelected" :options="brandOptions" size="sm" />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group label="Condition">
                <b-form-select v-model="conditionSelected" :options="conditionOptions" size="sm" />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group label="Offer Filter">
                <b-form-select v-model="onlyWithOffers" :options="filterOptions.demand.offers" size="sm" />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group label="Type">
                <b-form-select v-model="typeSelected" :options="filterOptions.demand.type" size="sm" />
              </b-form-group>
            </b-col>

            <b-col cols="12" md="2">
              <b-form-group label="Filter requested?">
                <b-form-select v-model="filterRequested" :options="filterOptions.demand.requested" size="sm" />
              </b-form-group>
            </b-col>
            <b-col cols="12" md="2">
              <b-form-group label="Requested by" style="position: relative">
                <b-input-group>
                  <b-form-input v-model="searchUser" size="sm"></b-form-input>
                  <b-input-group-append v-if="requestedByUser !== null">
                    <b-button @click="resetRequestedByUser" size="sm">X</b-button>
                  </b-input-group-append>
                </b-input-group>
                <b-list-group
                  style="position: absolute;top:100%;left:0;right:0;z-index: 1000;"
                  v-if="requestedByUser === null"
                >
                  <b-list-group-item
                    v-for="user in requestedUsersData"
                    :key="user.id"
                    @click="setRequestedByUser(user)"
                    button
                  >
                    {{ user.firstName }} {{ user.lastName }}
                  </b-list-group-item>
                </b-list-group>
              </b-form-group>
            </b-col>
          </b-row>
        </transition>
        <hr />
        <b-row>
          <b-col>
            <h5 @click="showPurchaseOfferFilter = !showPurchaseOfferFilter" class="filtertoggle">
              Purchase Offer Filter
              <b-icon-chevron-up scale="1.5" v-if="showPurchaseOfferFilter"/>
              <b-icon-chevron-down scale="1.5" v-else/>
            </h5>
          </b-col>
        </b-row>
        <transition name="fade">
          <b-row class="filter" v-show="showPurchaseOfferFilter">
            <b-col cols="12" sm="3">
              <b-form-group label="Merchant Email">
                <b-form-input v-model="supplierEmail" placeholder="Search in Merchant Email" size="sm"></b-form-input>
              </b-form-group>
            </b-col>
            <b-col cols="12" sm="3" class="purchase-offer-date-filter">
              <b-row class="purchase-offer-date-filter-row">
                <b-col cols="6" sm="6">
                  <label for="purchase-offer-from-date">From</label>
                  <input
                    type="text"
                    class="form-control form-control-sm purchase-offer-date"
                    id="purchase-offer-from-date"
                    v-model="purchaseOfferFromDate"
                    :class="!isValidDateRange ? 'error' : ''"
                  />
                </b-col>
                <b-col cols="6" sm="6">
                  <label for="purchase-offer-to-date">To</label>
                  <input
                    type="text"
                    class="form-control form-control-sm purchase-offer-date"
                    id="purchase-offer-to-date"
                    v-model="purchaseOfferToDate"
                    :class="!isValidDateRange ? 'error' : ''"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="12">
                  <b-button variant="primary" size="sm" block
                    @click="applyPurchaseOfferDateFilter()"
                    :disabled="!isValidDateRange"
                  >
                    Apply Date Filter
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" sm="3" class="purchase-offer-date-filter">
              <b-row>
                <b-col>
                  <b-form-group label="Purchase Offer Type">
                    <b-form-select
                      v-model="purchaseOfferTypeSelected"
                      :options="filterOptions.purchaseOffer.type"
                      size="sm"
                    />
                  </b-form-group>
                </b-col>
              </b-row>
            </b-col>
            <b-col cols="12" sm="3" class="purchase-offer-date-filter">
              <b-row class="purchase-offer-date-filter-row">
                <b-col cols="6" sm="6">
                  <label for="purchase-offer-stock-from-date">From</label>
                  <input
                    type="text"
                    class="form-control form-control-sm purchase-offer-date"
                    id="purchase-offer-stock-from-date"
                    v-model="purchaseOfferStockFromDate"
                    :class="!isValidStockDateRange ? 'error' : ''"
                  />
                </b-col>
                <b-col cols="6" sm="6">
                  <label for="purchase-offer-stock-to-date">To</label>
                  <input
                    type="text"
                    class="form-control form-control-sm purchase-offer-date"
                    id="purchase-offer-stock-to-date"
                    v-model="purchaseOfferStockToDate"
                    :class="!isValidStockDateRange ? 'error' : ''"
                  />
                </b-col>
              </b-row>
              <b-row>
                <b-col cols="12" sm="12">
                  <b-button variant="primary" size="sm" block
                    @click="applyPurchaseOfferStockDateFilter()"
                    :disabled="!isValidStockDateRange"
                  >
                    Apply Date Filter for Stock
                  </b-button>
                </b-col>
              </b-row>
            </b-col>
          </b-row>
        </transition>
        <hr />
        <b-row>
          <b-col cols="12" md="12" class="align-items-center">
            <b-button variant="secondary" size="sm" block
              @click="resetFilter()"
              :disabled="!filterActive"
            >
              Reset Filter <b-icon-arrow-counterclockwise/>
            </b-button>
          </b-col>
        </b-row>
        <hr />
        <b-row>
          <b-col cols="4" md="4">
            <b-form-group label="Page Size">
              <b-form-radio-group
                v-model="pageSize"
                :options="pageSizeOptions"
                name="pageSize"
                buttons
                button-variant="primary"
                size="sm"
              />
            </b-form-group>
          </b-col>
          <b-col cols="12" md="8" class="text-right">
            Showing {{ firstResultInView }} - {{ lastResultInView }} of <strong>{{ numberOfFilteredDemands }}</strong> /
            Total
            {{ numberOfTotalDemands }}
          </b-col>
        </b-row>
      </b-col>
    </b-row>

    <b-table
      :items="filteredDemands"
      :fields="demandDataFields"
      bordered
      borderless
      striped
      fixed
      stacked="sm"
      :per-page="pageSize"
      :current-page="currentPage"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :busy="!isDataLoaded"
      @row-clicked="showPurchaseOffers"
      :tbody-tr-class="demandRowClass"
    >
      <div slot="table-busy" class="text-center my-2">
        <b-spinner class="align-middle" />
        <strong>Loading...</strong>
      </div>

      <template v-slot:cell(imageUrl)="data">
        <b-img-lazy :id="data.item.demandId" :src="getThumbnail(data.item.imageUrl, 10)" alt="" />
        <b-tooltip :target="data.item.demandId" placement="left">
          <b-img :src="getThumbnail(data.item.imageUrl, 100)" fluid />
        </b-tooltip>
      </template>
      <template v-slot:cell(offers)="data">
        <b-badge>
          {{
            allPurchaseOffersByProductKeyVariantKey(
              data.item.productKey,
              data.item.variantKey,
              data.item.demandId,
              supplierEmail,
              purchaseOfferTypeSelected,
              requestedByUser,
            ).length
          }}
        </b-badge>
        &nbsp;
        <b-badge variant="primary" v-if="data.item.status === 'requested'">req</b-badge>
      </template>
      <template v-slot:cell(createdAt)="data">
        {{ formattedTime(data.item.createdAt) }}
      </template>
      <template slot="row-details" slot-scope="row">
        <div v-if="row.item.status === 'requested'" class="row">
          <b-col cols="1"></b-col>
          <b-col cols="11">
            Requested by :
            {{
              isBlockedByUser(
                row.item.demandId,
                allPurchaseOffersByProductKeyVariantKey(
                  row.item.productKey,
                  row.item.variantKey,
                  row.item.demandId,
                  supplierEmail,
                  purchaseOfferTypeSelected,
                  requestedByUser,
                ),
              )
            }}
          </b-col>
        </div>
        <b-row>
          <b-col cols="1"></b-col>
          <b-col cols="11">
            <b-row>
              <b-col cols="3">
                Ordernumber:<br /><strong>{{ row.item.orderNumber }}</strong>
              </b-col>
              <b-col cols="3">
                Linenumber:<br /><strong>{{ row.item.lineNumber }}</strong>
              </b-col>
              <b-col cols="3">
                Diff Tax Possible:<br />
                <b-badge variant="success" v-if="row.item.diffTaxPossible !== null && row.item.diffTaxPossible"
                  >Yes</b-badge
                >
                <b-badge variant="danger" v-else-if="row.item.diffTaxPossible !== null && !row.item.diffTaxPossible"
                  >No</b-badge
                >
              </b-col>
              <b-col cols="3">
                Price :<br /><strong>{{ row.item.unitPrice / 100 }} {{ row.item.unitCurrency }}</strong>
              </b-col>
            </b-row>
            <div class="d-none d-sm-flex row row-offer-heading">
              <b-col>
                <b-row class="row-offer-content" @click.stop>
                  <b-col cols="12" md="3" class="col-content">
                    Merchant Email / Message
                  </b-col>
                  <b-col cols="12" md="2" class="col-content">Accessible by</b-col>
                  <b-col cols="12" md="2" class="col-content">Condition</b-col>
                  <b-col cols="12" md="2" class="col-content">Offered</b-col>
                  <b-col cols="12" md="3" class="col-content">Actions</b-col>
                </b-row>
              </b-col>
            </div>
            <div
              class="row"
              v-for="purchaseOffer in allPurchaseOffersByProductKeyVariantKey(
                row.item.productKey,
                row.item.variantKey,
                row.item.demandId,
                supplierEmail,
                purchaseOfferTypeSelected,
                requestedByUser,
              )"
              :key="purchaseOffer.purchaseOfferId"
            >
              <admin-purchase-offer-row
                v-if="
                  purchaseOffer.state === PURCHASE_OFFER.STATE.OPEN ||
                    (purchaseOffer.state === PURCHASE_OFFER.STATE.REQUESTED &&
                      purchaseOffer.demandId === row.item.demandId)
                "
                :purchase-offer="purchaseOffer"
                :demand="row.item"
                @purchase-offer-accepted="$emit('purchase-offer-accepted')"
              />
            </div>
          </b-col>
        </b-row>
      </template>
    </b-table>
    <b-pagination v-model="currentPage" :total-rows="filteredDemands.length" :per-page="pageSize" align="center" />
  </b-container>
</template>

<script>
import store from '@/store/index';
import { addWeeks, format } from 'date-fns';
import Pikaday from 'pikaday';
import { timeFormatMixin } from 'Mixins/timeFormatMixin';
import demandMixin from 'Mixins/demand';
import AdminPurchaseOfferRow from 'Components/admin/demand/AdminPurchaseOfferRow';
import constants from 'Constants/constants';
import { GET_USER_ACTION, LOAD, RELOAD } from 'src/store/actionTypes';
import Demand from 'Constants/demand';
import PurchaseOffer from 'Constants/purchaseOffer';
import { mapActions, mapGetters, mapState } from 'vuex';
import ApiLoadingStatus from '@/api/statusTypes';
import { GET_ALL, GET_PURCHASEOFFER_FOR_DEMAND_FILTERED } from '../../store/getterTypes';

export default {
  name: 'AdminDemand',
  components: {
    AdminPurchaseOfferRow,
  },
  mixins: [timeFormatMixin, demandMixin],
  data: function() {
    return {
      demandDataFields: [
        {
          key: 'imageUrl',
          label: 'Image',
          thStyle: { width: this.calcColumnWidth(1) },
        },
        {
          key: 'createdAt',
          label: 'Created at',
          sortable: true,
          sortDirection: 'desc',
          thStyle: { width: this.calcColumnWidth(2) },
        },
        {
          key: 'productKey',
          label: 'Product',
          thStyle: { width: this.calcColumnWidth(1) },
        },
        {
          key: 'variantKey',
          label: 'Variant',
          thStyle: { width: this.calcColumnWidth(1) },
        },
        {
          key: 'brand',
          label: 'Brand',
          thStyle: { width: this.calcColumnWidth(1.5) },
        },
        {
          key: 'model',
          label: 'Model',
          thStyle: { width: this.calcColumnWidth(1.5) },
        },
        { key: 'referenceNumber', label: 'Referencenumber' },
        {
          key: 'offers',
          label: 'Offers',
          thStyle: { width: this.calcColumnWidth(1) },
        },
      ],
      sortBy: 'createdAt',
      sortDesc: false,
      currentPage: 1,
      pageSize: 20,
      pageSizeOptions: [
        { text: '10', value: 10 },
        { text: '20', value: 20 },
        { text: '50', value: 50 },
      ],
      totalRows: 0,
      newDataAvailable: false,
      lastDemandUpdate: null,
      lastPurchaseOfferUpdate: null,
      PURCHASE_OFFER: PurchaseOffer,
      searchUser: '',
      requestedByUser: null,
      status: '',
      brandSelected: '',
      conditionSelected: 'new',
      typeSelected: '',
      createdAtOrderAscending: true,
      textFilter: '',
      onlyWithOffers: 'withoffer',
      supplierEmail: '',
      demands: [],
      purchaseOffers: [],
      purchaseOffersStock: [],
      updateInterval: null,
      purchaseOfferFromDate: null,
      purchaseOfferToDate: null,
      purchaseOfferStockFromDate: null,
      purchaseOfferStockToDate: null,
      showDemandFilter: true,
      showPurchaseOfferFilter: true,
      purchaseOfferTypeSelected: '',
      localConstants: {
        STATUS_LOADING: 'loading',
        STATUS_ERROR_LOADING: 'errorLoading',
        STATUS_FINISHED_LOADING: 'finishedLoading',
      },
      filterRequested: null,
      filterOptions: {
        demand: {
          type: [
            { value: '', text: 'All' },
            { value: Demand.TYPE.DIVA, text: 'Customer Order' },
            { value: Demand.TYPE.STRATEGIC, text: 'Strategic Stock' },
            {
              value: Demand.TYPE.NEVER_OUT_OF_STOCK,
              text: 'Never Out Of Stock',
            },
          ],
          requested: [
            { value: null, text: 'All' },
            { value: true, text: 'Requested' },
            { value: false, text: 'Open' },
          ],
          offers: [
            { value: 'withoffer', text: 'Only with offers' },
            { value: 'withoutoffer', text: 'Only without offers' },
            { value: 'everything', text: 'All demands' },
          ],
        },
        purchaseOffer: {
          type: [
            { value: '', text: 'All' },
            { value: PurchaseOffer.TYPE.MANUAL, text: 'Manually created' },
            {
              value: PurchaseOffer.TYPE.AUTOMATIC,
              text: 'Automatically created',
            },
          ],
        },
      },
    };
  },
  watch: {},
  computed: {
    ...mapGetters(['internalUsers', 'userByEmail']),
    ...mapGetters('demands', {
      allDemands: GET_ALL,
    }),
    ...mapGetters('purchaseOffers', {
      allPurchaseOffersByProductKeyVariantKey: GET_PURCHASEOFFER_FOR_DEMAND_FILTERED,
    }),
    ...mapState('demands', {
      demandsStatus: 'status',
      demandsLastUpdate: 'lastUpdate',
    }),
    ...mapState('purchaseOffers', {
      purchaseOffersStatus: 'status',
      purchaseOffersLastUpdate: 'lastUpdate',
    }),
    requestedUsersData() {
      if (this.internalUsers.length <= 0 || this.searchUser.length < 3) return [];
      return this.internalUsers.filter(
        (user) =>
          user.username.toLowerCase().includes(this.searchUser.toLowerCase()) ||
          user.firstName.toLowerCase().includes(this.searchUser.toLowerCase()) ||
          user.lastName.toLowerCase().includes(this.searchUser.toLowerCase()) ||
          (user.firstName + ' ' + user.lastName).toLowerCase().includes(this.searchUser.toLowerCase()) ||
          user.email.toLowerCase().includes(this.searchUser.toLowerCase()),
      );
    },
    isDataLoaded() {
      return (
        this.demandsStatus === ApiLoadingStatus.STATUS_SUCCESSFUL &&
        this.purchaseOffersStatus === ApiLoadingStatus.STATUS_SUCCESSFUL
      );
    },
    isValidDateRange() {
      return this.parseDate(this.purchaseOfferFromDate) <= this.parseDate(this.purchaseOfferToDate);
    },
    isValidStockDateRange() {
      return this.parseDate(this.purchaseOfferStockFromDate) <= this.parseDate(this.purchaseOfferStockToDate);
    },
    lastUpdate() {
      let latestUpdate =
        this.lastDemandUpdate > this.lastPurchaseOfferUpdate ? this.lastDemandUpdate : this.lastPurchaseOfferUpdate;
      latestUpdate =
        this.demandsLastUpdate > this.purchaseOffersLastUpdate ? this.demandsLastUpdate : this.purchaseOffersLastUpdate;
      return latestUpdate !== null ? this.formattedTime(latestUpdate) : '';
    },
    filterActive() {
      return this.textFilter !== '' || this.brandSelected !== '' || this.conditionSelected !== '';
    },
    numberOfTotalDemands() {
      return this.allDemands.length;
    },
    numberOfFilteredPages() {
      return Math.ceil(this.filteredDemands.length / this.pageSize);
    },
    numberOfFilteredDemands() {
      return this.filteredDemands.length;
    },
    brandOptions() {
      let brands = [];
      let lowerCasedBrands = [];
      this.allDemands.forEach((demand) => {
        if (demand.brand === null || demand.brand === '') {
          return false;
        }
        if (!lowerCasedBrands.includes(demand.brand.toLowerCase())) {
          brands.push(demand.brand);
          lowerCasedBrands.push(demand.brand.toLowerCase());
        }
      });
      brands.sort();
      brands.unshift({ value: '', text: 'All' });
      return brands;
    },
    conditionOptions() {
      let conditions = [{ value: '', text: 'All' }];
      this.allDemands.forEach((demand) => {
        if (
          demand.condition === null ||
          demand.condition === undefined ||
          demand.condition === '' ||
          Array.isArray(demand.condition) ||
          typeof demand.condition === 'object'
        ) {
          return false;
        }
        if (!conditions.includes(demand.condition.toLowerCase())) {
          conditions.push(demand.condition.toLowerCase());
        }
      });
      return conditions.sort();
    },
    firstResultInView() {
      return Math.min(this.filteredDemands.length, (this.currentPage - 1) * this.pageSize + 1);
    },
    lastResultInView() {
      if (this.currentPage * this.pageSize > this.filteredDemands.length) {
        return this.filteredDemands.length;
      }
      return this.currentPage * this.pageSize;
    },
    filteredDemands() {
      return this.allDemands.filter((demand) => {
        if (demand.brand === null) {
          demand.missingData = true;
          return true;
        }

        let demandBrand = demand.brand.toLowerCase();
        let selectedBrand = this.brandSelected.toLowerCase();
        if (demandBrand.indexOf(selectedBrand) === -1) {
          return false;
        }

        if (
          !Array.isArray(demand.condition) &&
          typeof demand.condition !== 'object' &&
          demand.condition !== undefined &&
          demand.condition.toLowerCase().indexOf(this.conditionSelected.toLowerCase()) === -1
        ) {
          return false;
        }

        if (this.typeSelected !== '') {
          if (this.typeSelected === Demand.TYPE.DIVA && !this.isDivaDemand(demand)) {
            return false;
          }
          if (this.typeSelected === Demand.TYPE.STRATEGIC && !this.isStrategicDemand(demand)) {
            return false;
          }
          if (this.typeSelected === Demand.TYPE.NEVER_OUT_OF_STOCK && !this.isNeverOutOfStockDemand(demand)) {
            return false;
          }
        }

        let demandModel = demand.model.toLowerCase();
        let demandVariantKey = demand.variantKey.toLowerCase();
        let demandReferenceNumber = demand.referenceNumber.toLowerCase();

        let textFilter = this.textFilter.toLowerCase().trim();
        if (
          demandBrand.indexOf(textFilter) === -1 &&
          demandModel.indexOf(textFilter) === -1 &&
          demandVariantKey.indexOf(textFilter) === -1 &&
          demandReferenceNumber.indexOf(textFilter) === -1
        ) {
          return false;
        }
        let purchaseOffers = this.allPurchaseOffersByProductKeyVariantKey(
          demand.productKey,
          demand.variantKey,
          demand.demandId,
          this.supplierEmail,
          this.purchaseOfferTypeSelected,
          this.requestedByUser,
        );
        if (this.onlyWithOffers === 'withoffer') {
          if (purchaseOffers.length < 1) {
            return false;
          }
        } else if (this.onlyWithOffers === 'withoutoffer') {
          if (purchaseOffers.length > 0) {
            return false;
          }
        }

        if (this.filterRequested !== null) {
          if (!this.filterRequested && demand.status === Demand.STATE.REQUESTED) {
            return false;
          } else if (this.filterRequested && demand.status !== Demand.STATE.REQUESTED) {
            return false;
          }
        }
        return true;
      });
    },
  },
  methods: {
    ...mapActions({ getUsers: GET_USER_ACTION }),
    ...mapActions('demands', {
      getDemands: LOAD,
      reloadDemands: RELOAD,
    }),
    ...mapActions('purchaseOffers', {
      loadPurchaseOffers: LOAD,
      reloadPurchaseOffers: RELOAD,
    }),
    setRequestedByUser(user) {
      this.searchUser = user.firstName + ' ' + user.lastName;
      this.requestedByUser = user;
    },
    resetRequestedByUser() {
      this.searchUser = '';
      this.requestedByUser = null;
    },
    calcColumnWidth(columnCount) {
      return (100 / 12) * columnCount + '%';
    },
    isBlockedByUser(demandId, purchaseOffers) {
      if (undefined === purchaseOffers) return '';
      let blockedByPurchaseOffer = purchaseOffers.filter((purchaseOffer) => {
        return purchaseOffer.state === this.PURCHASE_OFFER.STATE.REQUESTED && purchaseOffer.demandId === demandId;
      });
      if (blockedByPurchaseOffer.length > 0) {
        let user = this.internalUsers.find((user) => user.id === blockedByPurchaseOffer[0].lastUpdatedByUserId);
        if (undefined !== user) {
          return user.firstName + ' ' + user.lastName + ' @ ' + this.formattedTime(blockedByPurchaseOffer[0].updatedAt);
        }
      }
      return '';
    },
    showPurchaseOffers(row) {
      row._showDetails = !row._showDetails;
    },
    getThumbnail(url, width) {
      return url !== ''
        ? url.replace('cdn-products.chronext.com', 'chronexttime.imgix.net') +
            '?w=' +
            width +
            '&auto=format&fm=jpg&q=55&usm=50&usmrad=1.5&dpr=2&fit=clamp'
        : '';
    },
    demandRowClass(item, type) {
      if ('row' === type) {
        return 'demand demand--' + item.type;
      }
    },
    applyPurchaseOfferDateFilter() {
      this.reloadPurchaseOffers({
        startDate: this.purchaseOfferFromDate,
        endDate: this.purchaseOfferToDate,
        startDateStock: this.purchaseOfferStockFromDate,
        endDateStock: this.purchaseOfferStockToDate,
      });
    },
    applyPurchaseOfferStockDateFilter() {
      this.reloadPurchaseOffers({
        startDate: this.purchaseOfferFromDate,
        endDate: this.purchaseOfferToDate,
        startDateStock: this.purchaseOfferStockFromDate,
        endDateStock: this.purchaseOfferStockToDate,
      });
    },
    resetFilter() {
      this.brandSelected = '';
      this.textFilter = '';
      this.onlyWithOffers = 'withoffer';
      this.conditionSelected = 'new';
      this.purchaseOfferTypeSelected = '';
    },
    loadData() {
      this.getUsers();
      this.getDemands();
      this.loadPurchaseOffers({
        startDate: this.purchaseOfferFromDate,
        endDate: this.purchaseOfferToDate,
        startDateStock: this.purchaseOfferStockFromDate,
        endDateStock: this.purchaseOfferStockToDate,
      });
    },
    reloadData() {
      this.newDataAvailable = false;
      this.reloadDemands();
      this.reloadPurchaseOffers({
        startDate: this.purchaseOfferFromDate,
        endDate: this.purchaseOfferToDate,
        startDateStock: this.purchaseOfferStockFromDate,
        endDateStock: this.purchaseOfferStockToDate,
      });
    },
    checkForUpdates() {
      // demand-service lastUpdate
      store.dispatch('checkForUpdates').then((response) => {
        if (response.data.lastUpdate !== undefined) {
          if (this.demandsLastUpdate < response.data.lastUpdate) {
            this.newDataAvailable = true;
          }
        }
      });
      // offer-service’s purchase offer lastUpdate
      store.dispatch('checkForPurchaseOfferUpdates').then((response) => {
        if (response.data.lastUpdate !== undefined) {
          if (this.purchaseOffersLastUpdate < response.data.lastUpdate) {
            this.newDataAvailable = true;
          }
        }
      });
    },
  },
  mounted() {
    this.purchaseOfferFromDate = format(addWeeks(new Date(), -2), constants.DATE_FORMAT);
    this.purchaseOfferToDate = format(new Date(), constants.DATE_FORMAT);
    this.purchaseOfferStockFromDate = format(addWeeks(new Date(), -4), constants.DATE_FORMAT);
    this.purchaseOfferStockToDate = format(new Date(), constants.DATE_FORMAT);

    let self = this;
    this.$nextTick(function() {
      new Pikaday({
        field: document.getElementById('purchase-offer-from-date'),
        format: constants.DATE_FORMAT,
        toString(date) {
          return self.formattedDate(date);
        },
        parse(dateString) {
          return self.parseDate(dateString);
        },
        onSelect: function() {
          self.purchaseOfferFromDate = this.toString();
        },
      });

      new Pikaday({
        field: document.getElementById('purchase-offer-to-date'),
        format: constants.DATE_FORMAT,
        toString(date) {
          return self.formattedDate(date);
        },
        parse(dateString) {
          return self.parseDate(dateString);
        },
        onSelect: function() {
          self.purchaseOfferToDate = this.toString();
        },
      });

      new Pikaday({
        field: document.getElementById('purchase-offer-stock-from-date'),
        format: constants.DATE_FORMAT,
        toString(date) {
          return self.formattedDate(date);
        },
        parse(dateString) {
          return self.parseDate(dateString);
        },
        onSelect: function() {
          self.purchaseOfferStockFromDate = this.toString();
        },
      });

      new Pikaday({
        field: document.getElementById('purchase-offer-stock-to-date'),
        format: constants.DATE_FORMAT,
        toString(date) {
          return self.formattedDate(date);
        },
        parse(dateString) {
          return self.parseDate(dateString);
        },
        onSelect: function() {
          self.purchaseOfferStockToDate = this.toString();
        },
      });
    });

    this.loadData();
    this.updateInterval = setInterval(this.checkForUpdates, 30000);
  },
  beforeDestroy() {
    clearInterval(this.updateInterval);
  },
};
</script>

<style lang="scss">
.btn-reload-demands-and-purchase-offers {
  position: fixed;
  z-index: 100;
  right: 40px;
  top: 50px;
}

.purchase-offer-date-filter {
  padding-bottom: 10px;
}

.purchase-offer-date-filter-row {
  margin-bottom: 1em;
}

.page-size-selection .page-link {
  font-size: 0.85rem;
  padding: 0.35rem 0.5rem;
}

.row-header {
  padding-top: 3px;
  padding-bottom: 5px;
  border: 1px solid #fff;
  background-color: #777;
  color: #fff;
}

.col-container-demand-list-header {
  .col-header {
    padding-top: 3px;
    padding-bottom: 3px;
  }
}

.col-loading {
  padding: 30px 0;
}

.select-brand {
  width: 100%;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.4s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.col-container-demand-list {
  border-top: 1px solid #cccccc;
}

.sortable {
  cursor: pointer;
}

.filtertoggle {
  cursor: pointer;
}

input.error {
  border-color: var(--red);
}
.demand {
  cursor: pointer;
  position: relative;
  td:first-child {
    position: relative;
  }
  td:first-child::before {
    content: '';
    width: 3px;
    height: 100%;
    background: transparent;
    display: block;
    left: 0;
    position: absolute;
    top: 0;
  }
  &--old {
    td:first-child::before {
      background: var(--red);
    }
  }
  &--strategic {
    td:first-child::before {
      background: var(--warning);
    }
  }
  &--never_out_of_stock {
    td:first-child::before {
      background: var(--info);
    }
  }
  &--diva {
    td:first-child::before {
      background: var(--success);
    }
  }
}
.row-offer-heading {
  font-size: 1rem;
  margin-top: 3px;
  color: #fefefe;
  background-color: #999;
  border-left: 4px solid #333;
}
</style>
